//
// Generated class EventLog
//

/// <reference path="EventLog_ManagedObject.ts" />

class EventLog extends EventLog_ManagedObject
{

}
